import { includes } from 'lodash';
import React from 'react';
import { connect } from 'react-redux';
import RowClick from '../../../../common/RowClick';
import Table from '../../../../common/table/Table';
import TextBlink from '../../../../common/table/TextBlink';
import { getColorPrice } from '../../../../helpers/Color';
import { getDataFollowKeyByDot, getRanking } from '../../../../helpers/Common';
import {
  formatPrice,
  formatTextFloat,
  formatVolume,
} from '../../../../helpers/Text';
import CellHover from '../../../../market/watchlist/summary/CellHover';
import '../../../technical.scss';
import { REDUCER_NAME } from '../reducer';
import Const from './Const';
import { I18n } from 'react-redux-i18n';
import TradingViewUrl from '../../../../common/TradingViewUrl';
import { compose } from 'redux';

class TableAggressive extends React.PureComponent {
  getDataFromRedux = state =>
    state[REDUCER_NAME].listObjectDeceptiveAggressiveDataByTicker;

  getClassName = (item, listColumn) => {
    return getColorPrice(
      getDataFollowKeyByDot(item, listColumn.PRICE),
      getDataFollowKeyByDot(item, listColumn.REF_PRICE),
      getDataFollowKeyByDot(item, listColumn.HIGH_PRICE),
      getDataFollowKeyByDot(item, listColumn.LOW_PRICE),
      'text',
    );
  };

  handleScroll = e => {
    const { totalPage, page, onLoadMore } = this.props;
    const bottom =
      e.target.scrollHeight - Math.round(e.target.scrollTop) ===
      e.target.clientHeight;
    if (page >= totalPage) return;
    if (bottom) {
      onLoadMore(page + 1);
    }
  };

  schema = (listColumn, i18nTitleKey) =>
    Object.keys(Const.listColumn).map((item, index) => {
      const key = listColumn[item];
      const title = `${i18nTitleKey}.${item}`;

      const result = {
        key,
        title,
      };

      if (index === 0) {
        return {
          ...result,
          thStyle: { width: '40px' },
          isString: true,
          render: (text, item) => (
            <CellHover organCode={item.organCode} isShowDeleteIcon={false}>
              <TextBlink item={item} tradingDate="tradingDate">
                <TradingViewUrl code={item.organCode} />
                &nbsp;{text}
              </TextBlink>
            </CellHover>
          ),
        };
      }

      if (includes([listColumn.PRICE], key)) {
        return {
          ...result,
          render: (text, item) => {
            const className = this.getClassName(item, listColumn);
            return (
              <TextBlink
                item={item}
                tradingDate="tradingDate"
                className={className}
              >
                {formatTextFloat(formatPrice(text))}
              </TextBlink>
            );
          },
        };
      }

      if (includes([listColumn.VOLUME], key)) {
        return {
          ...result,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(formatVolume(text))}
              </TextBlink>
            );
          },
        };
      }

      if (includes([listColumn.VOLUME_BU_SD], key)) {
        const getValue = item => {
          const bu = getDataFollowKeyByDot(
            item,
            Const.listColumn.TOTAL_VOLUME_BU,
          );
          const sd = getDataFollowKeyByDot(
            item,
            Const.listColumn.TOTAL_VOLUME_SD,
          );

          return bu / sd;
        };
        return {
          ...result,
          valueFromItem: getValue,
          render: (text, item) => {
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {formatTextFloat(getValue(item))}
              </TextBlink>
            );
          },
        };
      }

      if (includes([listColumn.RANK], key)) {
        return {
          ...result,
          thTooltip: I18n.t('table.technical.ranking'),
          render: (text, item) => {
            const total = getDataFollowKeyByDot(
              item,
              Const.listColumn.TOTALRANK,
            );
            return (
              <TextBlink item={item} tradingDate="tradingDate">
                {getRanking(text, total)}
              </TextBlink>
            );
          },
        };
      }

      if (
        [
          Const.listColumn.AVG_VOLUME,
          Const.listColumn.TOTAL_VOLUME_BU,
          Const.listColumn.TOTAL_VOLUME_SD,
        ].includes(key)
      ) {
        return {
          ...result,
          render: text => (
            <TextBlink item={item} tradingDate="tradingDate">
              {formatTextFloat(formatPrice(text))}
            </TextBlink>
          ),
        };
      }

      return {
        ...result,
        render: text => (
          <TextBlink item={item} tradingDate="tradingDate">
            {formatTextFloat(text, 0)}
          </TextBlink>
        ),
      };
    });

  render() {
    const { isLoading, onSort, scrollRef, ids } = this.props;
    if (ids.length === 0 && !isLoading) {
      return (
        <div className="empty-data-msg text-s-color-3">
          {I18n.t('tasignals.deceptiveDataMessage.noDataForFilter')}
        </div>
      );
    }
    return (
      <RowClick>
        {onRowClick => (
          <Table
            onSort={onSort}
            clickRow={onRowClick}
            scrollRef={scrollRef}
            thValign="top"
            isLoading={isLoading}
            ids={ids}
            resizable={true}
            columnDraggable={false}
            rowDraggable={false}
            onScrollFunction={this.handleScroll}
            hideColumns={Const.listHideColumn}
            getDataFromRedux={this.getDataFromRedux}
            isShowHeadLoading={true}
            schema={this.schema(Const.listColumn, 'tasignals.aggressiveHeader')}
          />
        )}
      </RowClick>
    );
  }
}

const mapStateToProps = state => {
  return {
    i18n: state.i18n,
    ids: state[REDUCER_NAME].listDeceptiveAggressiveDataTicker,
    isLoading: state[REDUCER_NAME].isLoading,
    totalPage: state[REDUCER_NAME].totalPage,
  };
};

const enhance = compose(connect(mapStateToProps));

export default enhance(TableAggressive);
